module.exports = __webpack_public_path__ + "static/media/level-up.2369d9cb.svg";